import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1023"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M14.649 9.861c-.089-.052-2.212-1.265-5.34-.185-1.339.465-3.578.077-3.601.072a.7.7 0 0 0-.245 1.378c.064.012 1.003.175 2.108.175.727 0 1.526-.071 2.195-.302 2.487-.861 4.11.033 4.174.07a.702.702 0 0 0 .958-.25.698.698 0 0 0-.249-.958zm0 2.663c-.089-.052-2.212-1.265-5.34-.185-1.339.463-3.578.076-3.601.072a.7.7 0 0 0-.245 1.378c.064.012 1.002.175 2.107.175.727 0 1.527-.071 2.196-.302 2.487-.86 4.11.033 4.174.07a.703.703 0 0 0 .958-.25.698.698 0 0 0-.249-.958z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M14.57 3.689s-6.977-2.06-9.323-2.672a.695.695 0 0 0-.836.497L1.028 14.12a.708.708 0 0 0 .476.847.71.71 0 0 0 .876-.485l1.462-5.45 10.829-4.214a.607.607 0 0 0-.101-1.129z" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }